import { usePrintReport } from "../../../../hooks";
import { ButtonBarReport } from "../../../../ui";

export const CalculatorReportButtonBar = () => {
  const { downloadPdf } = usePrintReport();
  return <ButtonBarReport handleDownloadReportClick={downloadPdf} />;
};
